import React from 'react';
import _get from 'lodash/get';
import PlatformFooter from 'cccisd-footer';
import { Html } from 'cccisd-wysiwyg';
import style from './style.css';

const Appdefs = window.cccisd.appDefs;

const Footer = () => {
    const grantAttribution = _get(Appdefs, 'app.footer.grantAttribution', '');

    return (
        <>
            <div className={style.upper}>
                <div className="container">
                    <div className={'d-flex flex-wrap justify-content-between ' + style.flex}>
                        <div>
                            <div>
                                <Html content={grantAttribution} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={style.lower}>
                <PlatformFooter grantAttribution="" />
            </div>
        </>
    );
};

export default Footer;
